export default {
    adminSubMenu: {
        home: 'Home',
        hive: 'Hive',
        news: 'News',
        menuOpenAndClose: 'Open/Close Menu',
        toggleTheme: 'Dark/Light Theme',
        toggleWorkspace: 'Organazation',
        settings: 'Settings',
        general: 'General',
        accountSettings: 'Account Settings',
        organization: 'Organization',
        members: 'Members',
        suggestAFeature: 'Suggest a Feature',
        help: 'Help'
    },
    settings: {
        settings: 'Settings',
        accountSettings: 'Account Settings',
        profile: 'Profile',
        personalDetails: 'Personal details',
        deviceActivity: 'Device activity',
        password: 'Password',
        created: 'Created',
        update: 'Update',
        signedInDevices: 'Signed-in Devices',
        signOut: 'Sign Out',
        save: 'Save',
        username: 'Username',
        email: 'Email',
        firstName: 'First Name',
        lastName: 'Last Name',
        currentSession: 'Current Session',
        ipAddress: 'IP Address',
        lastAccessed: 'Last Accessed',
        clients: 'Clients',
        started: 'Started',
        expires: 'Expired',
        yourSessionExpiredSoon: 'Your session will expire soon, would you like to continue?',
        yourSessionExpiredSoonMessage:
            'Your session will expire soon! You can continue the current session.',
        stayLoggedIn: 'Stay Logged In',
        yourSessionExpired: 'Your session has expired',
        yourSessionExpiredMessage:
            'Your admin panel session has expired. No worries, you can log in again anytime.',
        reLogin: 'Re-login',
        logout: 'Logout',
        create: 'Create',
        warning: 'Warning',
        createOrganization: 'Create organization',
        uploadIcon: 'Click here to upload icon',
        name: 'Name',
        description: 'Description',
        deleteOrganizationTooltip: 'Delete organization',
        deleteOrganization: 'Are you sure you want to delete the organization?',
        leaveOrganization: 'Are you sure you want to leave the organization?',
        delete: 'Delete',
        leave: 'Leave',
        cancel: 'Cancel',
        deleteComplete: 'You have successfully deleted the organization.',
        leaveComplete: 'You have successfully left the organization.',
        somethingWentWrong: 'Something went wrong, please try again later.',
        editOrganization: 'Edit {name} organization',
        myOrganizations: 'My Organizations',
        teamManagement: 'Team Management',
        requiredField: 'Required field',
        minMaxCharacters: '{text} 1-255 characters are required!',
        organizationCharacters: 'The origanization name must be between',
        members: 'Members of {name}',
        invitation: {
            title: 'Invitation List',
            email: 'E-mail',
            scopes: 'Roles',
            status: 'Invitation Status',
            revoke: 'Revoke Invitation',
            revokeNotice: 'You want to revoke the invitation? This modification is permanent.',
            confirmRevokeInvitation: 'Sure, you want to revoke?',
            cancelRevokeInvitation: 'Cancel revoke',
            success: 'Invitation Success',
            successRevoke: 'Successfully revoked invitation',
            errorRevoke: 'Error while revoked invitation',
            statuses: {
                pending: 'Pending',
                expired: 'Expired',
                declined: 'Declined',
                revoked: 'Revoked',
                accepted: 'Accepted'
            }
        },

        userManager: {
            organization: {
                scope: {
                    read: 'Read',
                    update: 'Modify',
                    delete: 'Delete',
                    'create-campaign': 'Mange Campaign (limited)',
                    'create-hive': 'Mange Hive (limited)',
                    'mange-files': 'Mange Files',
                    'manage-permission': 'Permission Manager',
                    'manage-permission-list': 'Permission List',
                    'manage-permission-grant': 'Permission Grant',
                    'manage-permission-revoke': 'Permission Revoke'
                }
            }
        }
    },
    invite: {
        title: 'You invited to {organization} organization',
        scopes: 'You accesses',
        expiredAt: 'This invitation will expire at: {expiredAt}',
        accept: 'Accept',
        decline: 'Decline',
        userCreateTitle: 'You Credentials',
        userEmailNotice: 'You will use the your email address where the invitation is arrived.',
        accepted: {
            title: 'This invitation is accepted',
            instruction:
                'Your invitation is accepted, you have to click on the link bellow or go and login into Prizific system'
        },
        declined: {
            title: 'This invitation is declined',
            instruction: 'Your declined this invitation, the invitation is no longer available'
        },
        revoked: {
            title: 'This invitation is no longer available',
            instruction: 'Your invitation is no longer available'
        },
        expired: {
            title: 'This invitation is expired',
            instruction: 'Your invitation is no longer available'
        },
        form: {
            firstName: 'First Name',
            lastName: 'Last Name',
            password: 'Password Name',
            rePassword: 'Password Confirmation'
        },
        validation: {
            required: 'Required field',
            length: 'Length should be {min} to {max}',
            passwordFormat:
                'Password must contain 1 Uppercase letter, on lowercase latter and one number',
            passwordConfirm: 'The confirmation is not match with your password'
        }
    }
}
